<div class="main-info-wrapper">
  @if (iconData(); as iconData) {
    <gc-icon
      class="error-icon"
      [iconName]="iconData.iconName"
      [color]="iconData.iconColor"
      [size]="'large'"
    ></gc-icon>
  }
  <div class="text-container">
    @if (errorTitle(); as errorTitle) {
      <gc-text [variant]="'supportiveHeading'">{{
        errorTitle | translate
      }}</gc-text>
    }
    @if (errorString(); as errorString) {
      <gc-text [variant]="errorTitle() ? 'largeParagraph' : 'smallHeading'">{{
        errorString | translate
      }}</gc-text>
    }
  </div>
  @if (refreshPageButton()) {
    <gc-button
      [variant]="'secondary'"
      [iconPosition]="'right'"
      [icon]="'circularArrows'"
      [iconSize]="'medium'"
      (clicked)="handleOnClickedRefreshPage()"
      >{{ 'refreshPage' | translate }}</gc-button
    >
  }
  @if (navigateToUrl()) {
    <gc-link [internalLinkPath]="navigateToUrl()">
      {{ 'goToPage' | translate }}
    </gc-link>
  }
</div>
@if (traceId(); as traceId) {
  <app-trace-id-contact-information [traceId]="traceId" />
}
